module.exports = __webpack_public_path__ + "img/zakopane-logo-transparent.49c642af.png";